import React from "react";

const WalletIcon = ({ width }) => {
  return (
    <svg
      viewBox='-4.5 0 63 63'
      xmlns='http://www.w3.org/2000/svg'
      fill='#000000'
      width={width}
    >
      <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
      <g
        id='SVGRepo_tracerCarrier'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></g>
      <g id='SVGRepo_iconCarrier'>
        {" "}
        <g id='Group_89' data-name='Group 89' transform='translate(-604 -37)'>
          {" "}
          <path
            id='Path_120'
            data-name='Path 120'
            d='M646.509,78.451,605,91V65l40.294-12.182A2.1,2.1,0,0,1,648,54.827V76.442A2.1,2.1,0,0,1,646.509,78.451Z'
            fill='#ffc2c2'
            stroke='#333'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
          ></path>{" "}
          <path
            id='Path_121'
            data-name='Path 121'
            d='M643,85H615V38h28Z'
            fill='#cbff94'
            stroke='#333'
            strokeMiterlimit='10'
            strokeWidth='2'
          ></path>{" "}
          <path
            id='Path_122'
            data-name='Path 122'
            d='M650.171,99H605V65h45.171A3.829,3.829,0,0,1,654,68.829V95.171A3.829,3.829,0,0,1,650.171,99Z'
            fill='#ffc2c2'
            stroke='#333'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
          ></path>{" "}
          <g id='Group_88' data-name='Group 88'>
            {" "}
            <g id='Group_87' data-name='Group 87'>
              {" "}
              <line
                id='Line_132'
                data-name='Line 132'
                y2='21'
                transform='translate(629 42)'
                fill='#ffffff'
                stroke='#333'
                strokeMiterlimit='10'
                strokeWidth='2'
              ></line>{" "}
              <g id='Group_86' data-name='Group 86'>
                {" "}
                <path
                  id='Path_123'
                  data-name='Path 123'
                  d='M629.092,52.5a3.752,3.752,0,1,1,3.875-3.75'
                  fill='none'
                  stroke='#333'
                  strokeMiterlimit='10'
                  strokeWidth='2'
                ></path>{" "}
                <path
                  id='Path_124'
                  data-name='Path 124'
                  d='M629.092,52.5a3.752,3.752,0,1,1-3.875,3.75'
                  fill='none'
                  stroke='#333'
                  strokeMiterlimit='10'
                  strokeWidth='2'
                ></path>{" "}
              </g>{" "}
            </g>{" "}
          </g>{" "}
          <path
            id='Path_125'
            data-name='Path 125'
            d='M657,87H646a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h11Z'
            fill='#ffc2c2'
            stroke='#333'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
          ></path>{" "}
          <circle
            id='Ellipse_28'
            data-name='Ellipse 28'
            cx='1'
            cy='1'
            r='1'
            transform='translate(645 81)'
            fill='#ffffff'
            stroke='#333'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
          ></circle>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export default WalletIcon;
